import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { randomBytes, createCipheriv, createDecipheriv } from "crypto";
import config from "@/lib/config";
import connectRedis from "@/lib/connectRedis";
import jwt from "jsonwebtoken";

var MySkpToken = /*#__PURE__*/function () {
  function MySkpToken(req, res) {
    var _config$myskpToken$re, _config$myskpToken$re2, _config$myskpToken$re3, _config$myskpToken, _config$myskpToken$re4;

    _classCallCheck(this, MySkpToken);

    this.req = req;
    this.res = res;
    this.redis = connectRedis({
      host: process.env.REDIS_HOST || ((_config$myskpToken$re = config.myskpToken.redis) === null || _config$myskpToken$re === void 0 ? void 0 : _config$myskpToken$re.host),
      port: process.env.REDIS_PORT || ((_config$myskpToken$re2 = config.myskpToken.redis) === null || _config$myskpToken$re2 === void 0 ? void 0 : _config$myskpToken$re2.port),
      keyPrefix: config.myskpToken.redis.prefix,
      db: (_config$myskpToken$re3 = config.myskpToken.redis) === null || _config$myskpToken$re3 === void 0 ? void 0 : _config$myskpToken$re3.db
    }, (_config$myskpToken = config.myskpToken) === null || _config$myskpToken === void 0 ? void 0 : (_config$myskpToken$re4 = _config$myskpToken.redis) === null || _config$myskpToken$re4 === void 0 ? void 0 : _config$myskpToken$re4.cluster);
  }

  _createClass(MySkpToken, [{
    key: "generateKey",
    value: function generateKey() {
      return randomBytes(32).toString("hex");
    }
  }, {
    key: "encrypt",
    value: function encrypt(payload, key) {
      var iv = randomBytes(16);
      var cipher = createCipheriv("aes-256-ctr", key, iv);
      var encrypted = Buffer.concat([cipher.update(JSON.stringify(payload), "utf-8", "buffer"), cipher.final("buffer")]);
      return Buffer.concat([iv, encrypted]).toString("hex");
    }
  }, {
    key: "decrypt",
    value: function decrypt(payload, key) {
      var buf = Buffer.from(payload, "hex");
      var iv = buf.slice(0, 16);
      var encrypted = buf.slice(16);
      var decipher = createDecipheriv("aes-256-ctr", key, iv);
      var decrypted = Buffer.concat([decipher.update(encrypted), decipher.final()]);
      return decrypted.toString("utf-8");
    }
  }, {
    key: "setPayload",
    value: function () {
      var _setPayload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
        var key;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                key = this.generateKey();
                _context.next = 3;
                return this.redis.multi().set(key, payload).expire(key, config.myskpToken.maxAge).exec();

              case 3:
                return _context.abrupt("return", key);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setPayload(_x) {
        return _setPayload.apply(this, arguments);
      }

      return setPayload;
    }()
  }, {
    key: "getPayload",
    value: function () {
      var _getPayload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.redis.get(key);

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getPayload(_x2) {
        return _getPayload.apply(this, arguments);
      }

      return getPayload;
    }()
  }, {
    key: "deletePayload",
    value: function deletePayload(token) {
      return this.redis.del(token);
    }
  }, {
    key: "publish",
    value: function () {
      var _publish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
        var encryptionKey, encrypted, key;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                encryptionKey = randomBytes(32);
                encrypted = this.encrypt(payload, encryptionKey);
                _context3.next = 4;
                return this.setPayload(encrypted);

              case 4:
                key = _context3.sent;
                return _context3.abrupt("return", jwt.sign({
                  key1: key,
                  key2: encryptionKey
                }, config.myskpToken.jwtSecret));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function publish(_x3) {
        return _publish.apply(this, arguments);
      }

      return publish;
    }()
  }, {
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(token) {
        var verifiedToken, payload, jsonStr;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                verifiedToken = jwt.verify(token, config.myskpToken.jwtSecret);
                _context4.next = 4;
                return this.getPayload(verifiedToken.key1);

              case 4:
                payload = _context4.sent;
                jsonStr = this.decrypt(payload, Buffer.from(verifiedToken.key2));
                return _context4.abrupt("return", JSON.parse(jsonStr));

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](0);
                console.log(_context4.t0);
                return _context4.abrupt("return", false);

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 9]]);
      }));

      function verify(_x4) {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
  }]);

  return MySkpToken;
}();

export { MySkpToken as default };